import { render, staticRenderFns } from "./s-step-card-panels.vue?vue&type=template&id=0954fbcf&scoped=true"
import script from "./s-step-card-panels.vue?vue&type=script&setup=true&lang=js"
export * from "./s-step-card-panels.vue?vue&type=script&setup=true&lang=js"
import style0 from "./s-step-card-panels.vue?vue&type=style&index=0&id=0954fbcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954fbcf",
  null
  
)

export default component.exports